import { render, staticRenderFns } from "./TitleInnerBox.vue?vue&type=template&id=20361cd0&scoped=true&lang=pug&"
var script = {}
import style0 from "./TitleInnerBox.vue?vue&type=style&index=0&id=20361cd0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20361cd0",
  null
  
)

export default component.exports